import React from "react"

import { InputMail } from "./Mail"
import { InputPassword } from "./Password"
import { InputPhone } from "./Phone"
import { InputCity } from "./City"
import { InputText } from "./Text"
import { InputDate } from "./Date"
import { InputNumber } from "./Number"
import { InputTextarea } from "./Textarea"
import { InputCheckbox } from "./Checkbox"
import { InputRadio } from "./Radio"
import { Select } from "./Select"
import { InputFile } from "./File"
import { InputXlsx } from "./Xlsx"

const FormElement = (props) => {
    const renderSwitch = (type) => {
        switch (type) {

            case "text":
                return <InputText {...props} />

            case "number":
                return <InputNumber {...props} />

            case "email":
                return <InputMail {...props} />

            case "city":
                return <InputCity {...props} />

            case "password":
                return <InputPassword {...props} />

            case "phone":
                return <InputPhone {...props} />

            case "date":
                return <InputDate {...props} />

            case "textarea":
                return <InputTextarea {...props} />

            case "checkbox":
                return <InputCheckbox {...props} />

            case "radio":
                return <InputRadio {...props} />

            case "select":
                return <Select {...props} />

            case "file":
                return <InputFile {...props} />

            case "xlsx":
                return <InputXlsx {...props} />

            default:
                return <InputText {...props} />
        }

    }
    return (
        <>
            {renderSwitch(props.type)}
        </>
    )

}


export default FormElement
